/**
 * Settings → My Profile autosave payloads. A name save sends ONLY that name part:
 * sending the other fields from page state once wrote an empty first and last name
 * over a real one when that state hadn't loaded. The title travels alone the same
 * way. Default company and group always travel as a pair (never with names) so the
 * server can check the group belongs to the company.
 */
import type { updateProfile } from '@/lib/adminApi';

export type ProfileAutosaveField = 'first_name' | 'last_name' | 'job_title' | 'default_company_id' | 'default_group_id';

export type ProfileFieldResult =
  | { ok: true; payload: Parameters<typeof updateProfile>[0] }
  | { ok: false; message: string };

export interface DefaultScope {
  default_company_id: string | null;
  default_group_id: string | null;
}

export function profileFieldUpdate(field: ProfileAutosaveField, value: string | null, scope: DefaultScope): ProfileFieldResult {
  if (field === 'first_name') {
    const first = (value ?? '').trim();
    if (!first) return { ok: false, message: 'First name cannot be blank' };
    return { ok: true, payload: { first_name: first } };
  }
  if (field === 'last_name') {
    return { ok: true, payload: { last_name: (value ?? '').trim() } };
  }
  if (field === 'job_title') {
    // '' is the server's clear.
    return { ok: true, payload: { job_title: (value ?? '').trim() } };
  }
  return {
    ok: true,
    payload: field === 'default_company_id'
      ? { default_company_id: value, default_group_id: scope.default_group_id }
      : { default_company_id: scope.default_company_id, default_group_id: value },
  };
}
